.link {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 1rem;
  border-radius: 0.5rem;
  border: 1px solid;
  text-align: center;
  position: relative;
  min-height: 120px;
  width: 100%;
  box-shadow:
    0 10px 15px -3px rgb(0 0 0 / 0.1),
    0 4px 6px -4px rgb(0 0 0 / 0.1);
  font-weight: 500;
}

.enabled {
  border-color: var(--brand-3);
  background-color: white;
  color: var(--brand-6);
  cursor: pointer;
  transition: all 200ms;
}

.enabled:hover {
  background-color: var(--button-secondary-hover-background-color);
  box-shadow:
    0 20px 25px -5px rgb(0 0 0 / 0.1),
    0 8px 10px -6px rgb(0 0 0 / 0.1);
}

.disabled {
  border-color: var(--common-gray-3);
  background-color: white;
  color: var(--common-gray-5);
  cursor: not-allowed;
  pointer-events: none;
}

.disabled [data-content='main'] {
  color: var(--common-gray-5);
}

.disabled [data-content='main'] :global(.text-brand-6) {
  color: var(--common-gray-5);
}
